import { createActionGroup, props } from '@ngrx/store';
import { AccessRoleTypes } from 'src/app/models/user.model';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Set RoughagePlusApp Role': props<{ role?: AccessRoleTypes }>(),
  },
});

export default UserActions;
